import React from 'react';
import { Gem } from 'lucide-react';

export function PremiumModal({ onClose }) {
  return (
    <div className="text-center">
      <div className="mx-auto mb-4 h-16 w-16 rounded-2xl bg-gradient-to-br from-primary-500 to-purple-600 text-white grid place-items-center shadow-lg">
        <Gem className="h-9 w-9" />
      </div>
      <h3 className="text-xl font-semibold text-gray-900">Premium Access Only</h3>
      <p className="mt-1 text-sm text-gray-600">This feature is available on the premium plan.</p>

      <div className="mt-6">
        <button
          onClick={onClose}
          className="inline-flex items-center justify-center px-4 py-2 rounded-md bg-primary-600 text-white hover:bg-primary-700"
        >
          Close
        </button>
      </div>
    </div>
  );
}


